<ng-container>
	<mat-card (cdkDragEnded)="_dragEnd($event);" (mousedown)="_mouseDown($event);" [cdkDragFreeDragPosition]="position" [ngStyle]="_visible()"
			  cdkDrag cdkDragBoundary=".desktop" class="drag-box shot-table panel">

		<div *ngIf="!locked" [ngClass]="{'active-panel-tab': _active(), 'panel-tab': !_active()}" fxLayout="row">
			<div fxFlex="fit-content" fxLayoutAlign="start">
				<button (click)="_visibleChange(false);" class="close-button" color="primary" mat-icon-button id="mat-close-button">
					<mat-icon class="close-icon">clear</mat-icon>
				</button>
			</div>
			<div class="panel-title" fxFlex="">{{title}}</div>
		</div>

		<mat-card-content class="panel-content">
			<div *ngIf="locked" cdkDragHandle></div>
			<div *ngIf="shots; else noData">
				<div *ngIf="shots.length > 0; else noData" fxLayout="row">
					<div *ngFor="let shot of shots">
						<aigia-score [shot]="shot" [size]="size" [subtype]="subtype" [type]="type"></aigia-score>
					</div>
				</div>
			</div>
			<ng-template #noData>
				<mat-card style="background-color:#cdcdcd;">
					<mat-card-header>
						<mat-card-title style="font-weight:900;color:#fdfdfd;">No data<br/>selected.</mat-card-title>
					</mat-card-header>
					<mat-card-content>
					</mat-card-content>
				</mat-card>
			</ng-template>
		</mat-card-content>
	</mat-card>
</ng-container>


